module.exports = __webpack_public_path__ + "media/bootstrap-icons/cast-647bf6f8.svg";